module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/auth/recover/recover.component.scss
// module id = ./src/app/routes/auth/recover/recover.component.scss
// module chunks = main